import {
  Button,
  Card,
  CardBody,
  Heading,
  Text,
  IconButton,
  VStack,
  Box,
  useToast,
  Stack,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useCartStore from '../../../../store/cartStore';
import { AiOutlineShoppingCart, AiOutlineDelete, AiOutlineArrowRight } from 'react-icons/ai';
import { CartContext } from '../../../../context/cart';
import { Badge, Flex, Tooltip } from '@chakra-ui/react';
import { MdHealing } from 'react-icons/md';

export const PackageCard = ({ packages }) => {
  const navigate = useNavigate();
  const { addToCartPlans, removeFromCart, cartPlans } = useContext(CartContext);
  const { removeItem } = useCartStore();
  const [loading, setLoading] = useState();
  const toast = useToast();
  const [addTocart, setAddToCart] = useState();

  useEffect(() => {
    if (packages && cartPlans) {
      setAddToCart(cartPlans.some(item => item._id === packages._id));
    }
  }, [cartPlans, packages]);

  return (
    <Card
      width={'100%'}
      height={'full'}
      borderRadius={24}
      variant={'elevated'}
      transition={'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'}
      border={'1px solid'}
      borderColor={'gray.100'}
      overflow="hidden"
      bg="white"
      _hover={{
        transform: 'translateY(-12px)',
        boxShadow: '2xl',
        borderColor: 'blue.200',
      }}
      role="group"
    >
      <CardBody p={6}>
        <Stack spacing={5}>
          <Flex justifyContent="space-between" alignItems="flex-start">
            <Box
              p={3}
              borderRadius="18px"
              bg="blue.50"
              color="blue.600"
              transition="all 0.3s"
              _groupHover={{ bg: 'blue.500', color: 'white' }}
            >
              <MdHealing size={28} />
            </Box>
            <VStack align="end" spacing={1}>
              <Badge colorScheme="blue" variant="solid" borderRadius="full" px={3} py={1} fontSize="xs">
                Package
              </Badge>
              <Text fontSize="xs" fontWeight="bold" color="green.500">
                30+ Tests Included
              </Text>
            </VStack>
          </Flex>

          <Stack spacing={3}>
            <Heading
              fontSize={['xl', '2xl']}
              fontWeight="extrabold"
              color="gray.800"
              lineHeight="tight"
              onClick={() => navigate(`/package?packageId=${packages._id}`)}
              _hover={{ color: 'blue.600', cursor: 'pointer' }}
              noOfLines={1}
            >
              {packages?.name}
            </Heading>
            <Text fontSize="sm" color="gray.500" noOfLines={3} lineHeight="relaxed">
              {packages?.description}
            </Text>
          </Stack>

          <Box
            p={4}
            bg="gray.50"
            borderRadius="xl"
            border="1px dashed"
            borderColor="gray.200"
            transition="all 0.3s"
            _groupHover={{ bg: 'blue.50', borderColor: 'blue.100' }}
          >
            <Flex justifyContent="space-between" alignItems="center">
              <VStack align="start" spacing={0}>
                <Text fontSize="xs" fontWeight="bold" color="gray.400" textTransform="uppercase">
                  Best Value
                </Text>
                <Heading fontSize="2xl" color="blue.600" fontWeight="extrabold">
                  ₹{packages?.price}
                </Heading>
              </VStack>
              <Tooltip label="View Details" placement="top" hasArrow>
                <IconButton
                  variant="ghost"
                  colorScheme="blue"
                  aria-label="See details"
                  borderRadius="full"
                  icon={<AiOutlineArrowRight />}
                  onClick={() => navigate(`/package?packageId=${packages._id}`)}
                />
              </Tooltip>
            </Flex>
          </Box>
        </Stack>
      </CardBody>

      <Box p={0} mt="auto">
        {addTocart ? (
          <Flex width="full">
            <Button
              flex={1}
              height="3.5rem"
              borderRadius={0}
              leftIcon={<AiOutlineShoppingCart />}
              colorScheme="blue"
              variant="solid"
              onClick={() => navigate('/cart')}
              _hover={{ bg: 'blue.600' }}
            >
              Checkout Now
            </Button>
            <IconButton
              aria-label="Remove from cart"
              icon={<AiOutlineDelete />}
              height="3.5rem"
              width="3.5rem"
              borderRadius={0}
              colorScheme="red"
              variant="ghost"
              onClick={() => {
                removeItem(packages._id);
                removeFromCart(packages);
                toast({
                  title: 'Removed from cart',
                  status: 'info',
                  isClosable: true,
                  duration: 3000,
                  position: 'top',
                });
              }}
            />
          </Flex>
        ) : (
          <Button
            width="full"
            height="3.5rem"
            borderRadius={0}
            bg="blue.600"
            color="white"
            fontSize="md"
            fontWeight="bold"
            leftIcon={<AiOutlineShoppingCart />}
            isLoading={loading}
            onClick={() => {
              setLoading(true);
              addToCartPlans(packages);
              setLoading(false);
              toast({
                title: 'Added To Cart!',
                status: 'success',
                isClosable: true,
                duration: 3000,
                position: 'top',
              });
            }}
            _hover={{ bg: 'blue.700' }}
            _active={{ bg: 'blue.800' }}
            transition="all 0.3s"
          >
            Book Package
          </Button>
        )}
      </Box>
    </Card>
  );
};
